import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';

import Box from '../box/box.jsx';
import Selector from './selector.jsx';
import styles from './asset-panel.css';
import bindAll from 'lodash.bindall';
import iconFont from '../../css/iconfont.css';
import {isMobile} from '../../lib/platform';

class AssetPanel extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleFileChange',
            'onFileAccept'
        ]);
    }

    handleFileChange (e) {
        if (this.props.onFileChange) {
            this.props.onFileChange(e);
        }
    }
    onFileAccept () {
        if (this.props.onFileAccept) {
            this.props.onFileAccept();
        }
    }

    render () {
        const {
            ...props
        } = this.props;

        return (
            <Box className={styles.wrapper}>
                <div
                    className={styles.header}
                >
                    {props.assetType === 'sound' ?
                        <div
                            className={styles.button}
                            onClick={props.onClickAddFromLibrary}
                        >
                            <i className={classNames(iconFont.iconfont, iconFont.iconTianjiashengyin)} />
                            <FormattedMessage
                                defaultMessage="Choose Sound"
                                description="Button in asset panel for adding sound from library"
                                id="gui.assetPanel.chooseSound"
                            />
                        </div> : props.assetType === 'costume' ?
                            <div
                                className={styles.button}
                                onClick={props.onClickAddFromLibrary}
                            >
                                <i className={classNames(iconFont.iconfont, iconFont.iconTianjiabeijing)} />
                                <FormattedMessage
                                    defaultMessage="Choose Costume"
                                    description="Button in asset panel for adding costume from library"
                                    id="gui.assetPanel.chooseCostume"
                                />
                            </div> :
                            <div
                                className={styles.button}
                                onClick={props.onClickAddFromLibrary}
                            >
                                <i className={classNames(iconFont.iconfont, iconFont.iconTianjiabeijing)} />
                                <FormattedMessage
                                    defaultMessage="Choose Backdrop"
                                    description="Button in asset panel for adding backdrop from library"
                                    id="gui.assetPanel.chooseBackdrop"
                                />
                            </div>
                    }
                    <div
                        className={classNames(styles.button, {
                            [styles.disable]: props.assetType === 'sound' && isMobile()
                        })}
                        onClick={props.assetType === 'sound' && isMobile() ? null : props.onClickUpload}

                    >
                        <i className={classNames(iconFont.iconfont, iconFont.iconShangchuan)} />
                        <FormattedMessage
                            defaultMessage="Upload"
                            description="Button in asset panel for upload asset from local"
                            id="gui.assetPanel.upload"
                        />
                        <input
                            accept={this.props.fileAccept}
                            className={styles.fileInput}
                            multiple="true"
                            ref={props.fileInput}
                            type="file"
                            onChange={this.handleFileChange}
                        />
                    </div>
                    {props.assetType === 'sound' ?
                        <div
                            className={styles.button}
                            onClick={props.onClickNew}
                        >
                            <i className={classNames(iconFont.iconfont, iconFont.iconHuatong)} />
                            <FormattedMessage
                                defaultMessage="Record"
                                description="Button in asset panel for record a sound"
                                id="gui.assetPanel.record"
                            />
                        </div> :
                        <div
                            className={styles.button}
                            onClick={props.onClickNew}
                        >
                            <i className={classNames(iconFont.iconfont, iconFont.iconZijihua)} />
                            <FormattedMessage
                                defaultMessage="Paint"
                                description="Button in asset panel for paint a costume or backdrop"
                                id="gui.assetPanel.paint"
                            />
                        </div>}
                </div>
                <Selector
                    className={styles.selector}
                    {...props}
                />
                {props.children}
            </Box>
        );
    }
}

AssetPanel.propTypes = {
    fileAccept: PropTypes.string,
    fileInput: PropTypes.func,
    onClickAddFromLibrary: PropTypes.func,
    onClickNew: PropTypes.func,
    onClickPlay: PropTypes.func,
    onClickUpload: PropTypes.func,
    onFileChange: PropTypes.func,
    ...Selector.propTypes
};

export default AssetPanel;
